module.exports = __webpack_public_path__ + "static/img/action-icon3.c42041b1.png";